export const nav_home = 'Home';
export const nav_treatments = 'Treatments';
export const nav_how_it_works = 'How It Works';
export const nav_supervision = 'Supervision';
export const nav_book_now = 'Start Now';

export const hero_title = 'Premium Dental Care in Turkey';
export const hero_subtitle = 'Save up to 70% on world-class dental treatments with full doctor supervision';
export const hero_cta_primary = 'Book Your Treatment';
export const hero_cta_secondary = 'View Procedures';

export const services_title = 'Our Dental Treatments';
export const services_subtitle = 'Comprehensive dental care with transparent pricing and quality guarantees';

export const service_implants_title = 'Dental Implants';
export const service_implants_desc = 'Permanent tooth replacement with titanium implants';
export const service_implants_turkey = 'Turkey';
export const service_implants_usa = 'USA/UK';

export const service_veneers_title = 'Porcelain Veneers';
export const service_veneers_desc = 'Transform your smile with custom veneers';

export const service_smile_title = 'Smile Makeover';
export const service_smile_desc = 'Complete smile transformation package';

export const service_orthodontics_title = 'Orthodontics';
export const service_orthodontics_desc = 'Braces and clear aligners for perfect teeth';

export const service_whitening_title = 'Teeth Whitening';
export const service_whitening_desc = 'Professional whitening for a brighter smile';

export const service_root_title = 'Root Canal';
export const service_root_desc = 'Pain-free root canal treatment';

export const service_crowns_title = 'Crowns & Bridges';
export const service_crowns_desc = 'Restore damaged teeth with quality crowns';

export const service_allon4_title = 'All-on-4';
export const service_allon4_desc = 'Full arch restoration with 4 implants';

export const how_title = 'How It Works';
export const how_subtitle = 'Your journey to a perfect smile in 4 simple steps';

export const how_step1_title = 'Book Your Treatment';
export const how_step1_desc = 'Choose your dental procedure and preferred dates online';

export const how_step2_title = 'Choose Supervision';
export const how_step2_desc = 'Select independent doctor, your own dentist, or our expert';

export const how_step3_title = 'Get Treated';
export const how_step3_desc = 'Receive world-class care at JCI-accredited clinics';

export const how_step4_title = 'Follow-up Care';
export const how_step4_desc = 'Continuous support and monitoring after treatment';

export const supervision_title = 'Doctor Supervision Options';
export const supervision_subtitle = 'Choose the supervision model that makes you feel most comfortable';

export const supervision_option1_title = 'Independent Third-Party Doctor';
export const supervision_option1_desc = 'An independent doctor with no clinic affiliation reviews your X-rays, scans, treatment plan, and final results';
export const supervision_option1_badge = 'Most Trusted';

export const supervision_option2_title = 'Your Own Doctor Back Home';
export const supervision_option2_desc = 'Your dentist stays involved, receives all records, and gets paid 10% of treatment cost for oversight';
export const supervision_option2_badge = 'Stay Connected';

export const supervision_option3_title = 'Our In-House Expert';
export const supervision_option3_desc = 'Choose one of our experienced specialists to supervise your entire treatment process';
export const supervision_option3_badge = 'Included';

export const why_title = 'Why Choose Us';
export const why_subtitle = 'The smart choice for quality dental care';

export const why_savings_title = 'Save 60-70%';
export const why_savings_desc = 'Premium dental care at a fraction of USA/UK prices';

export const why_quality_title = 'Quality Assurance';
export const why_quality_desc = 'JCI-accredited facilities and internationally certified medical professionals ensure excellence';

export const why_transparency_title = 'Full Transparency';
export const why_transparency_desc = 'Complete access to all treatment records, X-rays, and progress reports';

export const why_doctor_title = 'Doctor Involvement';
export const why_doctor_desc = 'Your trusted doctor can supervise and stay informed throughout the process';

export const why_support_title = '24/7 Support';
export const why_support_desc = 'Multilingual support team available around the clock';

export const why_results_title = 'Proven Results';
export const why_results_desc = 'Thousands of satisfied patients from over 50 countries';

export const testimonials_title = 'Patient Success Stories';
export const testimonials_subtitle = 'Real experiences from patients around the world';

export const testimonial1_text = 'I saved $18,000 on my dental implants and the quality was exceptional. Having my dentist back home review everything gave me complete peace of mind.';
export const testimonial1_name = 'Sarah Johnson';
export const testimonial1_location = 'Los Angeles, USA';
export const testimonial1_treatment = 'Dental Implants';

export const testimonial2_text = 'The third-party doctor supervision was brilliant. An independent expert reviewed my treatment plan and results. I felt completely safe throughout.';
export const testimonial2_name = 'James Mitchell';
export const testimonial2_location = 'London, UK';
export const testimonial2_treatment = 'Smile Makeover';

export const testimonial3_text = 'My dentist in Madrid was involved the whole time and earned 10% for his supervision. It was the perfect solution for getting affordable veneers.';
export const testimonial3_name = 'Maria Garcia';
export const testimonial3_location = 'Madrid, Spain';
export const testimonial3_treatment = 'Porcelain Veneers';

export const testimonial4_text = 'The All-on-4 procedure changed my life. The clinic was world-class and having continuous supervision made all the difference.';
export const testimonial4_name = 'Robert Chen';
export const testimonial4_location = 'Toronto, Canada';
export const testimonial4_treatment = 'All-on-4';

export const testimonial5_text = 'I was nervous about dental tourism, but the independent doctor supervision option eliminated all my concerns. Highly recommend!';
export const testimonial5_name = 'Emma Wilson';
export const testimonial5_location = 'Sydney, Australia';
export const testimonial5_treatment = 'Orthodontics';

export const testimonial6_text = 'Saved over £12,000 on my smile makeover. The transparency and doctor involvement made this the best decision I ever made.';
export const testimonial6_name = 'David Brown';
export const testimonial6_location = 'Manchester, UK';
export const testimonial6_treatment = 'Complete Smile Makeover';

export const cta_title = 'Ready to Transform Your Smile?';
export const cta_subtitle = 'Book your consultation today and start your journey to affordable, quality dental care';
export const cta_button = 'Book Your Treatment';
export const cta_contact = 'Or call us at';

export const footer_about_title = 'About Plexus Alliance';
export const footer_about_desc = 'Connecting patients worldwide with premium dental care in Turkey, supervised by trusted doctors.';

export const footer_services_title = 'Services';
export const footer_services_implants = 'Dental Implants';
export const footer_services_veneers = 'Veneers';
export const footer_services_orthodontics = 'Orthodontics';
export const footer_services_whitening = 'Whitening';
export const footer_services_allon4 = 'All-on-4';

export const footer_company_title = 'Company';
export const footer_company_about = 'About Us';
export const footer_company_supervision = 'Supervision Model';
export const footer_company_pricing = 'Pricing';
export const footer_company_contact = 'Contact';

export const footer_support_title = 'Support';
export const footer_support_faq = 'FAQ';
export const footer_support_booking = 'Booking Process';
export const footer_support_travel = 'Travel Guide';
export const footer_support_aftercare = 'Aftercare';

export const footer_contact_title = 'Contact Us';
export const footer_contact_email = 'Email';
export const footer_contact_phone = 'Phone';
export const footer_contact_whatsapp = 'WhatsApp';

export const footer_copyright = '© 2025 Plexus Alliance. All rights reserved.';
export const footer_privacy = 'Privacy Policy';
export const footer_terms = 'Terms of Service';

export const common = {
  // Navigation
  'nav.home': 'Home',
  'nav.treatments': 'Treatments',
  'nav.howItWorks': 'How It Works',
  'nav.supervision': 'Supervision',
  'nav.about': 'About',
  'nav.bookNow': 'Book Now',
  'nav.language': 'Language',

  // Hero
  'hero.badge': 'Real doctors. Real care. Real peace of mind.',
  'hero.title.line1': 'This Is Your Journey,',
  'hero.title.line2': 'Do Your Ultimate Healing',
  'hero.subtitle1': 'Whether it\'s pain you\'ve been ignoring, a smile you\'ve been hiding, or costs that kept you waiting — you don\'t have to wait any longer.',
  'hero.subtitle2': 'We make world-class dental care in Turkey feel safe, supported, and completely within reach — with a doctor watching over every step.',
  'hero.cta.primary': 'Start My Journey',
  'hero.cta.secondary': 'Talk to Someone First',
  'hero.feature1': 'Doctor-supervised from start to finish',
  'hero.feature2': 'Care that fits your life and your budget',
  'hero.feature3': 'Supported every step, near or far',

  // Services
  'services.badge': 'Your Journey Starts Here',
  'services.title': 'Treatments That Change How You Feel Every Day',
  'services.subtitle': 'Whether you\'re ready to smile without hesitation, eat without worry, or simply feel like yourself again — we\'re here to help you get there',
  'services.cta': 'Explore All Treatments',
  'services.swipeHint': 'Swipe to explore more treatments',
  'services.learnMore': 'Learn More',
  'services.startingFrom': 'Starting from',
  'services.perTooth': 'per tooth',

  // Service: Dental Implants
  'service.implants.title': 'Dental Implants',
  'service.implants.desc': 'Eat, laugh, and speak with full confidence again. Feel like yourself with teeth that look, feel, and function just like your natural ones.',
  // Service: Veneers
  'service.veneers.title': 'Porcelain Veneers',
  'service.veneers.desc': 'Stop hiding your smile in photos. Wake up every day loving what you see in the mirror with a smile that finally feels like you.',

  // Service: Smile Makeover
  'service.smile.title': 'Smile Makeover',
  'service.smile.desc': 'Transform how you feel about yourself. A complete smile makeover designed around your face, your life, and the confidence you deserve.',

  // Service: Orthodontics
  'service.orthodontics.title': 'Orthodontics',
  'service.orthodontics.desc': 'Straighten your teeth without the self-consciousness. Discreet treatment that fits your lifestyle and gives you the smile you\'ve always wanted.',

  // Service: Whitening
  'service.whitening.title': 'Teeth Whitening',
  'service.whitening.desc': 'Feel confident in every conversation. A brighter, whiter smile that makes you feel good about yourself every time you speak.',

  // Service: Root Canal
  'service.root.title': 'Root Canal Treatment',
  'service.root.desc': 'Stop living with tooth pain. Save your natural tooth and get back to enjoying life without constant discomfort or worry.',

  // Service: Crowns
  'service.crowns.title': 'Dental Crowns',
  'service.crowns.desc': 'Protect and restore damaged teeth so you can eat what you love again. Strong, natural-looking crowns that last for years.',

  // Service: All-on-4
  'service.allon4.title': 'All-on-4 Implants',
  'service.allon4.desc': 'Get your life back in just one day. A full set of permanent teeth that let you eat, smile, and live without limits or embarrassment.',

  // How It Works
  'how.badge': 'Simple Process',
  'how.title': 'How It Works',
  'how.subtitle': 'Four simple steps to get world-class dental care with complete transparency',
  'how.cta': 'Start Your Journey',

  'how.step1.number': '01',
  'how.step1.title': 'Book Your Treatment',
  'how.step1.desc': 'Choose your dental treatment and upload your X-rays or dental scans. Our team will review and create a personalized treatment plan.',

  'how.step2.number': '02',
  'how.step2.title': 'Choose Supervision',
  'how.step2.desc': 'Select your preferred supervision option: independent third-party doctor, your own dentist back home (gets paid 10%), or our in-house expert.',

  'how.step3.number': '03',
  'how.step3.title': 'Get Treated with Transparency',
  'how.step3.desc': 'Receive your treatment at our JCI-accredited clinic. Your chosen supervisor reviews all X-rays, scans, and treatment progress in real-time.',

  'how.step4.number': '04',
  'how.step4.title': 'Follow-up Care',
  'how.step4.desc': 'Continue care with your dentist back home who has full knowledge of your treatment. We provide all records and ongoing support.',

  // Supervision
  'supervision.badge': 'You\'re Protected Every Step',
  'supervision.title': 'Worried About Going Abroad for Dental Care?',
  'supervision.subtitle': 'That worry is completely valid — and it\'s exactly why we built this. Every patient gets a dedicated supervisor who watches over their treatment from day one to done.',
  'supervision.swipeHint': 'Swipe to explore options',
  'supervision.chooseOption': 'Choose this option when booking',

  'supervision.option1.title': 'Independent Third-Party Doctor',
  'supervision.option1.badge': 'Most Trusted',
  'supervision.option1.desc': 'Someone in your corner who answers only to you — not the clinic. They review every scan, approve every step, and make sure nothing gets missed.',
  'supervision.option1.feature1': 'Reviews your X-rays before anything begins',
  'supervision.option1.feature2': 'Approves your treatment plan independently',
  'supervision.option1.feature3': 'Checks in at every stage of your care',
  'supervision.option1.feature4': 'Confirms the final result meets the standard',
  'supervision.option1.feature5': 'Zero conflict of interest — they work for you',
  'supervision.option1.pricing': 'What you get: Full independent oversight',

  'supervision.option2.title': 'Your Own Doctor Back Home',
  'supervision.option2.badge': 'Most Comfortable',
  'supervision.option2.desc': 'The dentist you already trust stays part of your journey. They know your history, they know you — and they stay informed every step of the way.',
  'supervision.option2.feature1': 'Your dentist receives all records and scans',
  'supervision.option2.feature2': 'Kept in the loop at every treatment stage',
  'supervision.option2.feature3': 'Handles your follow-up care back home',
  'supervision.option2.feature4': 'Earns 10% of treatment cost for their time',
  'supervision.option2.feature5': 'Seamless continuity — no starting over',
  'supervision.option2.pricing': 'What you get: Familiar care, no gaps',

  'supervision.option3.title': 'Our In-House Expert',
  'supervision.option3.badge': 'Included',
  'supervision.option3.desc': 'A senior specialist with 15+ years of experience watches over your treatment on-site. You\'re never just a patient — you\'re a priority.',
  'supervision.option3.feature1': '15+ years of specialist experience',
  'supervision.option3.feature2': 'Present at the clinic throughout your care',
  'supervision.option3.feature3': 'Responds immediately if anything feels off',
  'supervision.option3.feature4': 'Holds every step to the highest standard',
  'supervision.option3.feature5': 'Already included — no extra cost to you',
  'supervision.option3.pricing': 'What you get: Expert eyes, always present',

  'supervision.why.title': 'You Shouldn\'t Have to Just Hope for the Best',
  'supervision.why.desc': 'Going abroad for dental treatment takes courage. You\'re trusting people you\'ve never met, in a country you may not know, with something as personal as your smile. We built our supervision system because we believe you deserve more than a promise — you deserve a real person watching over every decision made about your care. Not a checklist. Not a brochure. A human being who is accountable to you.',

  // CTA
  'cta.title.line1': 'Your Smile Has Been',
  'cta.title.line2': 'Waiting Long Enough',
  'cta.subtitle1': 'We know it\'s not easy to take this step. The uncertainty, the questions, the "what ifs" — we hear them every day. That\'s exactly why we\'re here.',
  'cta.subtitle2': 'Your first conversation is free, pressure-free, and completely on your terms. Just talk to us — we\'ll take it from there.',
  'cta.button.primary': 'I\'m Ready to Talk',
  'cta.button.secondary': 'Chat on WhatsApp',
  'cta.badge1': 'Real doctors. Real care.',
  'cta.badge2': 'No pressure. No rush.',
  'cta.badge3': 'You\'re supported every step.',
  'cta.badge4': 'Real results. Real people.',

  // Footer
  'footer.brand.desc': 'We believe everyone deserves to feel confident in their smile. We\'re here to make that possible — safely, honestly, and with a real doctor by your side.',
  'footer.cta': 'Book Consultation',
  'footer.treatments': 'Treatments',
  'footer.company': 'Company',
  'footer.resources': 'Resources',
  'footer.phone': 'Phone',
  'footer.email': 'Email',
  'footer.location': 'Location',
  'footer.locationValue': 'Istanbul, Turkey',
  'footer.copyright': '© {{year}} Plexus Alliance. All rights reserved.',
  'footer.poweredBy': 'Powered by Readdy',

  // About page
  'about.hero.badge': 'Our Story',
  'about.hero.title': 'We Built the Safety Net Dental Tourism Was Missing',
  'about.hero.subtitle': 'Plexus Alliance was founded on a simple belief: patients deserve an independent voice in their own treatment — especially when they\'re far from home.',
  'about.mission.badge': 'Our Mission',
  'about.mission.title': 'Transparent, supervised dental care for every patient, everywhere.',
  'about.mission.desc': 'We connect patients with world-class dental clinics in Istanbul while providing the independent oversight layer that most dental tourism companies simply don\'t offer.',
  'about.values.badge': 'What We Stand For',
  'about.values.title': 'Our Core Values',
  'about.value1.title': 'Independence',
  'about.value1.desc': 'Our supervisors answer only to you — never to the clinic.',
  'about.value2.title': 'Transparency',
  'about.value2.desc': 'Every record, every scan, every decision — fully visible to you.',
  'about.value3.title': 'Continuity',
  'about.value3.desc': 'Your care doesn\'t stop when you board your flight home.',
  'about.value4.title': 'Accessibility',
  'about.value4.desc': 'World-class dental care shouldn\'t be a privilege. We make it reachable.',

  // Treatments page
  'treatments.hero.badge': 'All Treatments',
  'treatments.hero.title': 'Find Your Treatment',
  'treatments.hero.subtitle': 'From single implants to full smile makeovers — every treatment is supervised, transparent, and priced fairly.',
  'treatments.filter.all': 'All Treatments',
  'treatments.filter.implants': 'Implants',
  'treatments.filter.cosmetic': 'Cosmetic',
  'treatments.filter.orthodontics': 'Orthodontics',
  'treatments.filter.restorative': 'Restorative',
  'treatments.cta.title': 'Not sure which treatment you need?',
  'treatments.cta.desc': 'Tell us what\'s bothering you — we\'ll review your case for free and recommend the right path.',
  'treatments.cta.button': 'Get a Free Assessment',

  // Book Treatment page
  'book.hero.badge': 'Start Your Journey',
  'book.hero.title': 'Book Your Treatment',
  'book.hero.subtitle': 'Fill in the details below and we\'ll get back to you within a few hours with a personalised plan.',
  'book.form.name': 'Full Name',
  'book.form.email': 'Email Address',
  'book.form.phone': 'Phone / WhatsApp',
  'book.form.treatment': 'Treatment of Interest',
  'book.form.supervision': 'Supervision Preference',
  'book.form.message': 'Tell us more (optional)',
  'book.form.submit': 'Send My Request',
  'book.form.submitting': 'Sending...',
  'book.form.success': 'Request sent! We\'ll be in touch within a few hours.',

  // Partner Registration page
  'partner.hero.badge': 'Partner With Us',
  'partner.hero.title': 'Join the Plexus Alliance Network',
  'partner.hero.subtitle': 'Are you a dentist, clinic, or healthcare professional? Partner with us and earn while helping your patients access world-class care.',
  'partner.form.submit': 'Submit Application',

  // How It Works page
  'hiw.hero.badge': 'The Process',
  'hiw.hero.title': 'How It Works',
  'hiw.hero.subtitle': 'From your first message to your final check-up — here\'s exactly what happens, step by step.',
  'hiw.faq.title': 'Still have questions?',
  'hiw.cta.title': 'Ready to take the first step?',
  'hiw.cta.subtitle': 'It starts with a single message. Tell us what you need — we\'ll handle everything from there.',
  'hiw.cta.button': 'Start My Journey',

  // Supervision page
  'sup.hero.badge': 'Your Protection',
  'sup.hero.title': 'Medical Supervision',
  'sup.hero.subtitle': 'The one thing most dental tourism companies don\'t offer — and the one thing that makes all the difference.',
  'sup.why.title': 'Most clinics work for themselves. We work for you.',
  'sup.options.title': 'Three ways to stay protected',
  'sup.pillars.title': 'What every supervised patient gets',
  'sup.compare.title': 'With supervision vs. without',
  'sup.faq.title': 'Questions about supervision',
  'sup.cta.title': 'Your health deserves an independent voice.',
  'sup.cta.button': 'Book With Supervision',

  // Common UI
  'common.learnMore': 'Learn More',
  'common.bookNow': 'Book Now',
  'common.startJourney': 'Start My Journey',
  'common.getStarted': 'Get Started',
  'common.contactUs': 'Contact Us',
  'common.readMore': 'Read More',
  'common.viewAll': 'View All',
  'common.close': 'Close',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.loading': 'Loading...',
  'common.error': 'Something went wrong. Please try again.',
  'common.required': 'This field is required',
  'common.optional': 'Optional',
  'common.saving': 'Saving from',
  'common.perTooth': 'per tooth',
  'common.included': 'Included',
  'common.mostTrusted': 'Most Trusted',
  'common.mostComfortable': 'Most Comfortable',
  'common.yearsExperience': 'years experience',
  'common.patients': 'patients',
  'common.countries': 'countries',
  'common.savings': 'savings',
};

export default common;
